module.exports = __webpack_public_path__ + "static/media/055-south-korea.73417f1f.svg";